import { getSupportEmail } from '@/shared/lib';

import { LabelingData } from './types';

// Russian manufacturer info shown for the CIS group on the RU cluster only
export const cisRuLabelingData: LabelingData['CIS'] = {
  nameOfProduct: '',
  manufacturer:
    'Общество с ограниченной ответственностью «ДИАГНОКАТ»\n' +
    '129337, г. Москва, вн. тер. г. муниципальный округ Ярославский, ул. Палехская, д. 21, эт/пом/ком 1/II-III/13\n' +
    'Место производства - 129090, Москва, Пр-т Мира 36 стр. 1, 5 этаж',
  contactInfo: {
    title: '',
    address: '',
    phoneNumber: '+7 (904) 954-10-43',
    email: getSupportEmail(),
  },
  lastUpdate: '',
  UDI: null,
  productVersion: '2.0',
  userManual: '',
  marking: undefined,
};

export const labelingData: LabelingData = {
  UK: {
    nameOfProduct: '',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: {
      title: 'Authorized representative in the European Union',
      address:
        'FREYR LIFE SCIENCES LTD\n' +
        '9 Greyfriars Road, Reading, Berkshire, \n' +
        'United Kingdom RG1 1NU',
      phoneNumber: '+44 2037012379',
      email: 'CH-REP@freyrsolutions.com',
    },
    lastUpdate: '',
    UDI: '',
    productVersion: '4.0',
    userManual: 'https://diagnocat.com/legal-info/user-manual/',
    marking: { CE: true, MD: true },
  },

  EU: {
    nameOfProduct: 'Diagnocat AIS',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: {
      title: 'Authorized representative in the European Union:',
      address:
        'Freyr Regulatory GmbH\n' +
        'Marie-Curie Straße 8,\n' +
        '79539 Lörrach/Germany',
      phoneNumber: '+49 6181 7079007',
      email: 'EAR@freyrsolutions.com',
    },
    lastUpdate: '',
    UDI: '860010268018',
    productVersion: '1.0',
    userManual: 'https://diagnocat.com/legal-info/user-manual/',
    marking: { CE: true, MD: true },
  },

  Australia: {
    nameOfProduct: 'Diagnocat AIS',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: {
      title: 'Australian Sponsor:',
      address:
        'Taevas Life Sciences Pty Ltd \n' +
        '46 Dora St,\n' +
        'Blacktown,\n' +
        'NSW 2148, Australia',
      phoneNumber: '',
      email: '',
    },
    lastUpdate: '',
    UDI: '860010268018',
    productVersion: '1.0',
    userManual:
      'https://drive.google.com/file/d/1AFERsIp5DVEb_bH1Wcb6BKk90zDCPaNR/view?usp=sharing',
    marking: { CE: true, MD: true },
  },

  Switzerland: {
    nameOfProduct: '',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: {
      title: 'Authorized representative in the European Union',
      address:
        'Freyr Life Sciences GmbH,\n' +
        'Bahnhofplatz,\n' +
        'CH-6300 Zug,\n' +
        'Switzerland',
      phoneNumber: '+41 225087129',
      email: 'CH-REP@freyrsolutions.com',
    },
    lastUpdate: '',
    UDI: '',
    productVersion: '4.0',
    userManual: 'https://diagnocat.com/legal-info/user-manual/',
    marking: { CE: true, MD: true },
  },

  US: {
    nameOfProduct: '',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: undefined,
    lastUpdate: '',
    UDI: '860010268063',
    productVersion: '1.0',
    userManual:
      'https://drive.google.com/file/d/1I7ziGV0gwVM4DZvEpqUdWI7I3nFBdjq7/view?usp=sharing',
    marking: { MD: true, rxOnly: true, iso15223: true },
  },

  Mexico: {
    nameOfProduct: '',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: undefined,
    lastUpdate: '',
    UDI: '',
    productVersion: '4.0',
    userManual: 'https://diagnocat.com/legal-info/user-manual/',
    marking: { CE: true, MD: true },
  },

  Canada: {
    nameOfProduct: 'Diagnocat AIS',
    manufacturer:
      'DGNCT LLC 333 Southeast 2nd Avenue 20th Floor – #563 Miami, FL 33131 \n' +
      'DGNCT LLC 333 Sud-Est, 2e Avenue 20ème étage#563 Miami, Floride 33131, Etats-Unis',
    contactInfo: undefined,
    lastUpdate: '',
    UDI: '860010268070',
    productVersion: '2.0',
    userManual:
      'https://drive.google.com/file/d/1rXOpSFtgWhf-_C-pckaArv4Bt7CDfkvH/view?usp=sharing',
    userManualFr:
      'https://drive.google.com/file/d/1GoXw8RnI_1V0TlGAo5H3jChXOzuKQ27A/view?usp=sharing',
    marking: { CE: true, MD: true },
  },

  Israel: {
    nameOfProduct: '',
    manufacturer:
      'DGNCT LLC\n' +
      '333 Southeast 2nd Avenue \n' +
      '20th Floor – #563 \n' +
      'Miami, FL 33131',
    contactInfo: undefined,
    lastUpdate: '',
    UDI: '',
    productVersion: '4.0',
    userManual: 'https://diagnocat.com/legal-info/user-manual/',
    marking: { CE: true, MD: true },
  },

  CIS: {
    nameOfProduct: '',
    manufacturer:
      'Diagnocat LLC\n' +
      '21 Palekhskaya Street, Floor/Office/Room 1/II-III/13 Yaroslavl Municipal District, Moscow Intra-City Area 129337\n' +
      'Russian Federation',
    contactInfo: undefined,
    lastUpdate: '',
    UDI: null,
    productVersion: '2.0',
    userManual: '',
    marking: undefined,
  },
};
